module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av161-0122d5314d0db76bd6e327758b70be90.jpg";